// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.oyAXx84feUlUeqaxDy6E{align-items:center;display:flex}.DVu8dbAVHrgOL7w4IeqQ .chcS3VnzKwgsSFZeHedf{margin-left:6px}.chcS3VnzKwgsSFZeHedf{color:var(--content-primary-primary);max-width:150px}.S1YA_GGJkKg5kM_cBwDV{color:var(--content-neutral-primary);margin-left:8px}.waC3ZLYw15MGdpkf5kHR{height:auto;min-height:32px}.cksZsQdon3gRWW1AW2vu{background:var(--background-brand-subtle-primary);color:var(--content-primary-tertiary)}.JTNAU1wAwq0aMDO3ZgJR{color:var(--content-primary-primary)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `oyAXx84feUlUeqaxDy6E`,
	"wrap--checkbox": `DVu8dbAVHrgOL7w4IeqQ`,
	"wrapCheckbox": `DVu8dbAVHrgOL7w4IeqQ`,
	"title": `chcS3VnzKwgsSFZeHedf`,
	"count": `S1YA_GGJkKg5kM_cBwDV`,
	"dropdown": `waC3ZLYw15MGdpkf5kHR`,
	"highlighter": `cksZsQdon3gRWW1AW2vu`,
	"highlighter--label": `JTNAU1wAwq0aMDO3ZgJR`,
	"highlighterLabel": `JTNAU1wAwq0aMDO3ZgJR`
};
export default ___CSS_LOADER_EXPORT___;
